import { render } from "./SignSaleForFour.vue?vue&type=template&id=71292940&scoped=true"
import script from "./SignSaleForFour.vue?vue&type=script&lang=js"
export * from "./SignSaleForFour.vue?vue&type=script&lang=js"

import "./SignSaleForFour.vue?vue&type=style&index=0&id=71292940&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71292940"]])

export default __exports__